// --- Core ---
import {FC, ReactElement} from "react";
import {FieldRenderProps} from "react-final-form";
// --- Material UI ---
import {FormControl, FormControlLabel, FormHelperText, Switch} from "@mui/material";
import {StackedLabel} from "./shared/StackedLabel";

interface SwitchFieldProps extends FieldRenderProps<boolean> {
  disabled?: boolean;
  label: ReactElement;
  subLabel: ReactElement;
}

/**
 * SwitchField final-form input component
 */
export const SwitchField: FC<SwitchFieldProps> = ({disabled, input, meta: {touched, invalid, error}, label, subLabel, ...custom}) => (
  <FormControl disabled={disabled} fullWidth>
    <FormControlLabel
      label={<StackedLabel label={label} subLabel={subLabel}/>}
      control={<Switch checked={input.checked || input.value} onChange={input.onChange} color={"primary"}/>}
      {...custom}
    />
    {
      touched && invalid &&
        <FormHelperText>
          {error}
        </FormHelperText>
    }
  </FormControl>
);
